export const LOCALE_STORAGE_KEY = 'dashboard_locale'
export const SUPPORTED_LOCALES = ['en', 'zh', 'br', 'es']

export function getStoredLocale () {
  try {
    const locale = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (SUPPORTED_LOCALES.includes(locale)) {
      return locale
    }
  } catch (e) {}
  return 'en'
}

export function setStoredLocale (locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) {
    return
  }
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  } catch (e) {}
}
